import React, { useContext } from 'react'
import MainHeroSection from './sections/MainHero'
import HeroSection from './sections/Hero'
import AboutSection from './sections/About'
import AboutSection2 from './sections/About2'
import FeaturesCardSection from './sections/FeaturesCards'
import FeaturesSection from './sections/Features'
import MissionVisionSection from './sections/MissionVision'
import DownloadAppSection from './sections/DownloadApp'
import BannerCard from './sections/BannerCard'
import Pricing from './Pricing/Pricing'
import { Helmet } from 'react-helmet-async'
import Dashboard from './sections/Dashboard'

function HomePage() {
  
    return (
    <>
      <Helmet>
        <title>IzzyAI - AI-Powered Speech Therapy</title>
        <meta name="description"
          content="IzzyAI: Transforming speech therapy with innovative AI. Access 24/7 personalized care via an AI therapist powered by real-time recognition and analytics."
        />
      </Helmet>
      <MainHeroSection />
      <HeroSection />
      <AboutSection />
      <AboutSection2 />
      <Dashboard />
      {/* <RationaleSection /> */}
      <FeaturesCardSection />
      <FeaturesSection />
      {/* <ProductsSection /> */}
      {/* <NewsSection /> */}
      {/* <DirectorsSection /> */}
      <MissionVisionSection />
      <DownloadAppSection />
      {/* <FAQSection /> */}
      {/* <ContactForm /> */}
      {/* <ClinicForm/> */}
      <Pricing />
      <BannerCard />
    </>
  )
}

export default HomePage